import { __decorate } from 'tslib';
import { CommonModule } from '@angular/common';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeJLimitManager, UiPxTransferLimitModule } from '@wlp/ui-px-transfer-limit';

let TransferLimitService = class TransferLimitService {
    constructor(limitManager) {
        this.limitManager = limitManager;
    }
    getMyLimitsType(groupType) {
        return this.limitManager.getMyLimitsType(groupType);
    }
    getTransactionOptions() {
        return this.limitManager.getTransactionOptions();
    }
    getMyLimitsByType(type, uuidWL, uuidAP, period) {
        return this.limitManager.getMyLimitsByType(type, uuidWL, uuidAP, period);
    }
    requestLimitsAdjustment(transactionTypeId, typeId, uuidWL, uuidAP, valuePerPeriod, valuePerTransaction) {
        return this.limitManager.requestLimitsAdjustment(transactionTypeId, typeId, uuidWL, uuidAP, valuePerPeriod, valuePerTransaction);
    }
    requestMoreLimit(transactionTypeId, typeId, uuidWL, uuidAP, maximumValuePerPeriod, maximumValuePerTransaction) {
        return this.limitManager.requestMoreLimit(transactionTypeId, typeId, uuidWL, uuidAP, maximumValuePerPeriod, maximumValuePerTransaction);
    }
    getLimitsHistory(uuidWL, uuidAP, page, startDate, endDate, groupType, type, status, period, fieldOrder, directionSort, limit) {
        return this.limitManager.getLimitsHistory(uuidWL, uuidAP, page, startDate, endDate, groupType, type, status, period, fieldOrder, directionSort, limit);
    }
};
TransferLimitService.ctorParameters = () => [
    { type: SpeJLimitManager }
];
TransferLimitService.ngInjectableDef = ɵɵdefineInjectable({ factory: function TransferLimitService_Factory() { return new TransferLimitService(ɵɵinject(SpeJLimitManager)); }, token: TransferLimitService, providedIn: "root" });
TransferLimitService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], TransferLimitService);

let UiBsTransferLimitModule = class UiBsTransferLimitModule {
};
UiBsTransferLimitModule = __decorate([
    NgModule({
        declarations: [],
        providers: [
            TransferLimitService,
        ],
        imports: [CommonModule, FormsModule, IonicModule, UiBsUtilModule, UiPxTransferLimitModule]
    })
], UiBsTransferLimitModule);

/*
 * Public API Surface of ui-bs-notice
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TransferLimitService, UiBsTransferLimitModule };
//# sourceMappingURL=wlp-ui-bs-transfer-limit.js.map
